import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { parseDateOnlyToLocal } from '../utils/date-only.util';

@Pipe({
  name: 'utcDate',
  standalone: true,
})
export class UtcDatePipe implements PipeTransform {
  private locale = inject(LOCALE_ID);

  transform(value: string | Date | null | undefined, format = 'dd/MM/yyyy HH:mm'): string {
    if (!value) return '';

    let date: Date | null;
    if (typeof value === 'string') {
      const text = value.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
        date = parseDateOnlyToLocal(text); // fecha sin hora: no es un instante UTC
      } else {
        // Sin zona (ni Z ni ±hh:mm) el backend lo entrega en UTC.
        date = new Date(/(Z|[+-]\d{2}:?\d{2})$/.test(text) ? text : text + 'Z');
      }
    } else {
      date = value;
    }
    if (!date || isNaN(date.getTime())) return '';

    return new DatePipe(this.locale).transform(date, format) ?? '';
  }
}
